import { FC } from 'react';
import { CircleUser } from 'lucide-react';
import { DuplicateAccount, DuplicateUserRes } from '@src/types/users.ts';
import { CloseIcon } from '@features/ui/icons';

interface AccountCardProps {
  item: DuplicateAccount;
  onClick: (id: number) => void;
  onRemove?: (id: number) => void;
}

const AccountCard: FC<AccountCardProps> = ({ item, onClick, onRemove }) => {
  return (
    <div key={item.id} className={'relative border-b flex flex-col gap-2 pb-2'}>
      <p>
        <button className={'cursor-pointer'} onClick={() => onClick(item.id)}>
          <span className={'text-[#3490FF]'}>{item.username}</span>
        </button>
      </p>
      <p>
        {item.user.first_name} {item.user.last_name}
      </p>
      <div className={'absolute right-0 h-full flex'}>
        <button
          aria-label="Close"
          className="[&_svg]:!size-auto inline-flex appearance-none items-center justify-center rounded-full cursor-pointer hover:opacity-70"
          onClick={() => onRemove?.(item.id)}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

interface DuplicateCardProps {
  duplicateUser: DuplicateUserRes;
  onClick: (id: number) => void;
  onRemove?: (id: number) => void;
}

export const DuplicateCard: FC<DuplicateCardProps> = ({
  duplicateUser,
  onClick,
  onRemove,
}) => {
  const { actives, inactives, total, phone_number } = duplicateUser;

  return (
    <div className={'text-xs p-4 border rounded-[5px] w-full'}>
      <p>
        <strong>{total} </strong>accounts use phone:{' '}
        <strong>{phone_number}</strong>
      </p>
      <div className={'flex mt-6 gap-4 max-h-70 overflow-auto'}>
        <div className={'flex-1'}>
          <div className={'flex items-center gap-2'}>
            <CircleUser className={'size-4'} color={'#B6D72C'} />
            <p className={'font-bold text-sm'}>ACTIVE</p>
          </div>
          <div className={'mt-2 flex flex-col gap-2'}>
            {actives?.length ? (
              actives.map((item) => (
                <AccountCard
                  key={item.id}
                  item={item}
                  onClick={onClick}
                  onRemove={onRemove}
                />
              ))
            ) : (
              <p>no active accounts</p>
            )}
          </div>
        </div>
        <div className={'flex-1'}>
          <div className={'flex items-center gap-2'}>
            <CircleUser className={'size-4'} color={'red'} />
            <p className={'font-bold text-sm'}>INACTIVE</p>
          </div>
          <div className={'mt-2 flex flex-col gap-2'}>
            {inactives?.length ? (
              inactives.map((item) => (
                <AccountCard
                  key={item.id}
                  item={item}
                  onClick={onClick}
                  onRemove={onRemove}
                />
              ))
            ) : (
              <p>no inactive accounts</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
